import HiredApplicationsContainer from "../../../Components/Applications/HiredApplications";
import { useEffect } from "react";
import RoleGuard from "../../RoleGuard";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";

const HiredApplications = () => {
  const { user } = useAppSelector((state) => state.auth);
  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "Hired Applications";
  }, []);

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard
        userRoles={currentUserRoles}
        allowedRoles={["admin", "hr-officer", "recruiter"]}
      />

      {/* Main content */}
      <HiredApplicationsContainer/>
    </>
  );
};

export default HiredApplications;
